export const actions = {
    SET_USER_PERMISSIONS: "SET_USER_PERMISSIONS",
}

export const getUserPermissions = ( personId ) => {
    const permissions = JSON
        .parse(localStorage
        .getItem("permissions"))
        .find( item => ( item.type === 1 ) );
    return {
        type: actions.SET_USER_PERMISSIONS,
        personId,
        hasExecute: permissions ? permissions.execute : false,
    }
}




// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/permissions.js